exports.onRouteUpdate = ({ location }) => {
  if (location.pathname === '/' && window.RDStationForms) {
    new window.RDStationForms(
      'eye-lp-nova-contato-f0583034c5994558699f',
      'UA-64505833-1',
    ).createForm();
  }

  if (location.pathname.includes('/carrinho') && window.mixpanel) {
    window.mixpanel.init('33477f243a37ebf41321c1e7c936aa5a', {
      autocapture: true,
      record_sessions_percent: 100,
      mask_all_text: false,
    });
  }
};
